import { Trace } from '@/types/journey'

export const formatTrace = (moduleId: string, stepId: string, traces?: Trace[]) => {
  return {
    moduleId,
    stepId,
    isFirstOfModule: traces ? traces[traces.length - 1]?.moduleId !== moduleId : true
  }
}
